import type { RepositoryResult } from '../types/database.types'

export function unwrap<T>(result: RepositoryResult<T>): T {
  if (result.error) {
    throw new Error(result.error.message)
  }

  return result.data
}
